
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trope-quiz",
      function () {
        return require("private-next-pages/trope-quiz.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trope-quiz"])
      });
    }
  